import { render, staticRenderFns } from "./GroupPlanCompare.vue?vue&type=template&id=63ab2c87&lang=pug"
import script from "./GroupPlanCompare.vue?vue&type=script&lang=js"
export * from "./GroupPlanCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,CardPremiums: require('/home/docker/code/frontend/components/card/Premiums.vue').default,UserGroupPlanForm: require('/home/docker/code/frontend/components/UserGroupPlanForm.vue').default})
